import {msg, str} from '@lit/localize';
import {html,render} from 'lit-html';
import {eyeSvg,eyeClosedSvg} from './icons';

const validateForm = (form, formResponse) => {
    //add get element method so we can either use a node or an array of elements
    form.getElement = function(selector,all,type){
        if(this instanceof HTMLElement){
            if(type=='id'){
                selector = `#${selector}`;
            }
            else if(type=='class'){
                selector = `.${selector}`;
            }
            else if(type=='attribute'){
                selector = `[${selector}]`;
            }
            else if(type=='tag'){
                selector = `${selector}`;
            }
            if(all){
                return this.querySelectorAll(selector);
            }
            return this.querySelector(selector);
        }
        else{
            const results = this.filter(el=>{
                if(type=='id'){
                    return el.id == selector;
                }
                else if(type=='class'){
                    return el.classList.contains(selector);
                }
                else if(type=='attribute'){
                    let attr = selector.split('=');
                    if(attr.length>1){
                        return el.getAttribute(attr[0])==attr[1];
                    }
                    return el.getAttribute(selector);
                }
                else if(type=='tag'){
                    return el.tagName.toLowerCase()==selector;
                }
            })

            if(all){
                return results;
            }
            if(results.length>0){
                return results[0];
            }
            return null;
        }
    }
    formResponse.setAttribute('aria-live','polite');
    formResponse.innerHTML = '';

    let errors = [];
    let honeypot = form.getElement('hp',false,'class');
    if(honeypot?.value){
        return false;
    }
    let dependentFields = form.getElement('data-requiredif',true,'attribute');
    dependentFields.forEach(field=>{
        field.removeAttribute('aria-required');
        let dependency = field.dataset.requiredif;
        if(dependency){
            dependency = form.getElement(dependency,false,'id');
            if(dependency){
                let potentialValue = field.dataset.requiredifvalue;
                if(potentialValue){
                    if(dependency.value==potentialValue){
                        field.setAttribute('aria-required','true');
                    }
                }
                else{
                    if(dependency.type=='checkbox'){
                        if(dependency.checked){
                            field.setAttribute('aria-required','true');
                        }
                    }
                    else if(dependency.value){
                        field.setAttribute('aria-required','true');
                    }
                }
            }
        }
    });  
    
        // --- Manual InPerson location validation ---
    let formatSelect = form.getElement('format', false, 'id');
    let locationSelect = form.getElement('locationId', false, 'id');
    if (formatSelect?.value === 'InPerson' && locationSelect) {
        locationSelect.setAttribute('aria-required', 'true');
    }
    
    let requiredFields = form.getElement('aria-required',true,'attribute');
    requiredFields.forEach(field=>{ 
        field.removeAttribute('aria-invalid');
        field.removeAttribute('aria-describedby');
        field.classList.remove('error');
        let error = field.parentNode.querySelector(`#${field.id}_error`);
        if(error){
            error.remove();
        }
        let isValid = true;
        let isCheckbox = field.type=='checkbox';
        let isRadio = field.type=='radio';
        let isSelect = field.tagName.toLowerCase()=='select';
        let isInstanceHidden = field.name=='instances';
        if(isCheckbox&&!field.checked){
            isValid = false;
        }
        else if(isRadio){
            let radioGroup = form.getElement(`name=${field.name}`,true,'attribute');
            let radioChecked = Array.from(radioGroup).some(radio=>radio.checked);
            if(!radioChecked){
                isValid = false;
            }
        }
        else if(isSelect&&(field.value==''||field.value=='Select')){
            isValid = false;
        }
        else if(isInstanceHidden){
            if(field.value==''||field.value=='[]'){
                isValid = false;
            }
        }
        else if(field.type=='file'){ 
            if(field.files.length==0){
                isValid = false;
            }
            if(field.files.length>0){
                if(field.files[0].size==0){
                    isValid = false;
                }
            }
            if(field.parentNode.querySelector('[type=hidden]')&&!isValid){
                let hiddenField = field.parentNode.querySelector('[type=hidden]');
                if(hiddenField.value==''){
                    isValid = false;
                }
                else{
                    isValid = true;
                }
            }
            

        }
        else if(field.hasAttribute('aria-multiselectable')){
           return; //skip validation for multiselectable fields
        }
        else if(!field.value){
            isValid = false;
        }
        if(!isValid){
            field.setAttribute('aria-invalid','true');
            field.setAttribute('aria-describedby',field.id + '_error');
            field.classList.add('error');
            let span = document.createElement('span');
            span.id=field.id + '_error';
            span.classList.add('error_message');
            let message = field.dataset.error_message;
            if(!message){
                let label ='';
                if(field.labels?.length>0){
                    label = field.labels[0]?.innerText;
                    if(label){
                        if(label[label.length-1]=='*'||label[label.length-1]=='.'){
                            label = label.slice(0,-1);
                        }
                    }
                }
                if(field.dataset?.label){
                    label = field.dataset.label;
                }
                if(field.getAttribute('aria-labelledby')){
                    let labelId = field.getAttribute('aria-labelledby');
                    let labelElement = document.getElementById(labelId);
                    if(labelElement){
                        label = labelElement.innerText;
                        if(label[label.length-1]=='*'||label[label.length-1]=='.'){
                            label = label.slice(0,-1);
                        }
                    }
                }
                message = msg(str`${label} is required`);
            }
            span.innerHTML = message;
            errors.push(message);
            if(!isCheckbox){
                // field.insertAdjacentElement('afterend',span);
                const isFlatpickr =
                    field.classList.contains('flatpickr-input') &&
                    field.closest('.input_group');

                if(isFlatpickr){
                    const inputGroup = field.closest('.input_group');
                    const label = inputGroup?.querySelector('label');

                    if(label){
                        label.insertAdjacentElement('afterend', span);
                    }
                    else{
                        field.insertAdjacentElement('afterend', span);
                    }
                }
                else{
                    field.insertAdjacentElement('afterend', span);
                }
            }
            else{
                field.parentNode.appendChild(span);
            }
        }
    });
    
        
    let textareas = form.getElement('textarea',true,'tag');
    textareas.forEach(textarea=>{
        let customElement = textarea.closest('allin-textarea-counter');
        if(customElement){
            let validity = customElement.reportValidity();
            if(!validity){
                errors.push(customElement.validationMessage);
            }
        }
    });
        
    const emailFields = form.getElement('type=email',true,'attribute');
    //validate email
    if(emailFields.length>0){
        emailFields.forEach(emailField=>{
            if(emailField?.value){
                emailField.removeAttribute('aria-invalid');
                emailField.removeAttribute('aria-describedby');
                emailField.classList.remove('error');
                let error = emailField.parentNode.querySelector(`#${emailField.id}_error`);
                if(error){
                    error.remove();
                }
            
                const test = /\S+@\S+\.\S+/;
                const emailValid = test.test(emailField.value);
                if(!emailValid){
                    emailField.setAttribute('aria-invalid','true');
                    emailField.setAttribute('aria-describedby',emailField.id + '_error');
                    emailField.classList.add('error');
                    let span = document.createElement('span');
                    span.id=emailField.id + '_error';
                    span.classList.add('error_message');
                    let message = msg(str`Please enter a valid email address`);
                    span.innerHTML = message;
                    errors.push(message);
                    emailField.insertAdjacentElement('afterend',span);
                }
            }
        });
    }
    const urlFields = form.getElement('type=url',true,'attribute');
    //validate url
    if(urlFields.length>0){
        urlFields.forEach(urlField=>{
            if(!urlField.value) return;
            urlField.removeAttribute('aria-invalid');
            urlField.removeAttribute('aria-describedby');
            urlField.classList.remove('error');
            let error = urlField.parentNode.querySelector(`#${urlField.id}_error`);
            if(error){
                error.remove();
            }
            if(urlField?.value){
                try{
                    const currentUrl = new URL(urlField.value);
                    const { protocol } = currentUrl;

                    if (protocol !== 'http:' && protocol !== 'https:') {
                        currentUrl.protocol = 'https:';
                        urlField.value = currentUrl.toString();
                    }
                }
                catch(error){
                    urlField.value = `https://${urlField.value}`;
                }
            }
        });
    }

    let multiSelects = form.getElement('type=hidden',true,'attribute');
    if(multiSelects.length>0){
        multiSelects = Array.from(multiSelects);
        let ms = multiSelects.filter(el=>{
            return el.dataset.type=='multiselect'
        });
        ms.forEach(multiSelectInput=>{
            let multiSelect = multiSelectInput.closest('allin-multiselect');
            if(!multiSelect) return;
            multiSelect.removeAttribute('isinvalid');
            if(multiSelect.attributes?.required){
                let value = multiSelectInput.value;
                if(!value){
                    multiSelect.setAttribute('isinvalid',true);
                    let _msg = multiSelect.getAttribute('errormessage');
                    if(!_msg){
                        _msg = multiSelect.dataset?.error_message;
                        if(!_msg){
                            let label = multiSelect.querySelector('.listbox-label');
                            if(!label){
                                label = multiSelect.closest('.input-group').querySelector('label');
                            }
                            label = label.innerText;
                            if(label[label.length-1]=='*'||label[label.length-1]=='.'){
                                label = label.slice(0,-1);
                            }
                            _msg = msg(str`${label} is required`);
                        }
                    }
                    errors.push(_msg);
                }
            }
        })
    }

    let vatNumberField = form.getElement('vatNumber',false,'id');
    if(vatNumberField){
        if(vatNumberField.value){
            let vatCountryField = form.getElement('vatCountry',false,'id');
            if(!vatCountryField?.value){
                vatCountryField.setAttribute('aria-invalid','true');
                vatCountryField.setAttribute('aria-describedby',vatCountryField.id + '_error');
                vatCountryField.classList.add('error');
                let span = document.createElement('span');
                span.id=vatCountryField.id + '_error';
                span.classList.add('error_message');
                let message = msg(str`Billing Country is required when VAT Number is provided`,{desc: "Error message for required billing country when vat number is provided"});
                span.innerHTML = message;
                errors.push(message);
                vatCountryField.insertAdjacentElement('afterend',span);
            }
            else if(vatCountryField.value=='IE'){
                const ieVatPattern = /^IE[0-9]{7}[A-W][AH]$/;
                if(!ieVatPattern.test(vatNumberField.value)){
                    vatNumberField.setAttribute('aria-invalid','true');
                    vatNumberField.setAttribute('aria-describedby',vatNumberField.id + '_error');
                    vatNumberField.classList.add('error');
                    let span = document.createElement('span');
                    span.id=vatNumberField.id + '_error';
                    span.classList.add('error_message');
                    let message = msg(str`Please enter a valid Irish VAT Number with the pattern IE1234567AB`,{desc: "Error message for invalid Irish VAT number"});
                    span.innerHTML = message;
                    errors.push(message);
                    vatNumberField.insertAdjacentElement('afterend',span);
                }
            }
            else if(vatCountryField.value=='GB'){
                const gbVatPattern = /^GB([0-9]{9}|[0-9]{12}|(GD|HA)[0-9]{3})$/;
                if(!gbVatPattern.test(vatNumberField.value)){
                    vatNumberField.setAttribute('aria-invalid','true');
                    vatNumberField.setAttribute('aria-describedby',vatNumberField.id + '_error');
                    vatNumberField.classList.add('error');
                    let span = document.createElement('span');
                    span.id=vatNumberField.id + '_error';
                    span.classList.add('error_message');
                    let message = msg(str`Please enter a valid UK VAT Number with the pattern GB123456789`,{desc: "Error message for invalid UK VAT number"});
                    span.innerHTML = message;
                    errors.push(message);
                    vatNumberField.insertAdjacentElement('afterend',span);
                }
            }
        }
    }

    if(errors.length>0){
        let pError = document.createElement('p');
        render(msg(html`You were unable to submit this form because ${errors.length} ${errors.length>1?'fields have problems':'field has a problem'}. Please correct the errors below:<ul>${errors.map(error => html`<li>${error}</li>`)}</ul>`,{desc: "Error messages for invalid form submission"}),pError);
        formResponse.appendChild(pError);
        formResponse.classList.add('error');
        return false;
    }
    else{
        return true;
    }
}

const validationHandler = (field,message) => {
    field.setAttribute('aria-invalid','true');
    field.setAttribute('aria-describedby',field.id + '_error');
    field.classList.add('error');
    let span = document.createElement('span');
    span.id=field.id + '_error';
    span.classList.add('error_message');
    span.innerHTML = message;
    field.insertAdjacentElement('afterend',span);
}

const validationHandlerClear = (field) => {
    field.removeAttribute('aria-invalid');
    field.removeAttribute('aria-describedby');
    field.classList.remove('error');
    let error = field.parentNode.querySelector(`#${field.id}_error`);
    if(error){
        error.remove();
    }
}

const validateGToken = async (token, formResponse, action, nonce) => {
    let validation = false;
    try{
        if(!token){
            return false;
        }
        let response = await fetch(action, {
            body: JSON.stringify({token: token}),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'AllIn-Nonce': nonce,
                'AllIn-Validate': 'validate'
            }
        })
        response = await response.json();
        if(response.ok){
            validation = true;
        }
        else{
            formResponse.innerHTML = response.message;
        }
    }
    catch(error){
        formResponse.innerHTML = 'Something went wrong. Please refresh the page and try again.';
    };
    return validation; 
}

const gRecaptcha = async (formResponse,action,nonce) => {
    let recaptcha  = window.grecaptcha; 
    let gTokenValid = false;
    try{
        let token = await recaptcha.execute( import.meta.env.VITE_RECAPTCHA_SITE_KEY ,{action:'submit'})
        gTokenValid = validateGToken(token,formResponse,action,nonce);
    }
    catch(error){
        formResponse.innerHTML = 'Something went wrong. Please refresh the page and try again.';
    }
    return gTokenValid;
}

const validatePassword = (password) => {
    let errors = [];
    let isValid = true;
    if(password.length<8){
        isValid = false;
        errors.push(msg(str`Password must be at least 8 characters`));
    }
    if(!password.match(/[A-Z]/)){
        isValid = false;
        errors.push(msg(str`Password must contain at least one uppercase letter`));
    }
    if(!password.match(/[a-z]/)){
        isValid = false;
        errors.push(msg(str`Password must contain at least one lowercase letter`));
    }
    if(!password.match(/[0-9]/)){
        isValid = false;
        errors.push(msg(str`Password must contain at least one number`));
    }
    if(!password.match(/[^a-zA-Z0-9]/)){
        isValid = false;
        errors.push(msg(str`Password must contain at least one special character`));
    }
    if(!isValid){
        return errors;
    }
    else{
        return true;
    }
}

const validateEmail = (email) => {
    const test = /\S+@\S+\.\S+/;
    return test.test(email);
}

const hideRevealPassword = (e)=>{
    e.preventDefault();
    let passwordField = e.currentTarget.parentNode.querySelector(`#${e.currentTarget.dataset.switch}`);
    if(passwordField.type === 'password'){
        passwordField.type = 'text';
    }
    else{
        passwordField.type = 'password';
    }
    let show = e.target.dataset.show?e.target.dataset.show:msg(str`Show password`);
    let hide = e.target.dataset.hide?e.target.dataset.hide:msg(str`Hide password`);
    let showStr = `${eyeSvg.strings[0]}${show}`;
    let hideStr = `${eyeClosedSvg.strings[0]}${hide}`;
    e.currentTarget.setAttribute('aria-pressed',e.currentTarget.getAttribute('aria-pressed')==='true'?'false':'true');
    e.currentTarget.setAttribute('aria-label',e.currentTarget.getAttribute('aria-pressed')==='true'?hide:show);
    e.currentTarget.innerHTML = e.currentTarget.getAttribute('aria-pressed')==='true'?hideStr:showStr;
}

const setFileValueFromDataUrl = async (fileInput,{file,name}) => {
    //get blob from dataurl
    let response = await fetch(file);
    let blob = await response.blob();
    //create file from blob
    let extension = name.split('.').pop();
    let newFile = new File([blob], name, {type:`image/${extension}`,lastModified:new Date().getTime()});
    //set file on input
    let container = new DataTransfer();
    container.items.add(newFile);
    fileInput.files = container.files;
    fileInput.dispatchEvent(new Event('change'));
}

const decodeEntities=(str)=>{
    if(typeof str !== 'string'){
        return str;
    }
    str = str.replace('\\','');
    var element = document.createElement('div');
    var entity = /&(?:#x[a-f0-9]+|#[0-9]+|[a-z0-9]+);?/ig;
    str = str.replace(entity, function(m) {
        element.innerHTML = m;
        return element.textContent;
    });
    element.remove();
    return str;
}

const lockForm = (formId,uid, restUrl,nonce) => {
    fetch(`${restUrl}?action=lock_form&form_id=${formId}&uid=${uid}`, 
        {headers: {
            'AllIn-Nonce': nonce,
    }})
}

const releaseFormLock = (formId,uid, restUrl,nonce) => {
    fetch(`${restUrl}?action=release_form_lock&form_id=${formId}&uid=${uid}`, 
        {headers: {
            'AllIn-Nonce': nonce,
        }})
}

const releaseFormLockwithBeacon = (formId, uid, restUrl, nonce) => {
    if(navigator.sendBeacon){
        let url = `${restUrl}?action=release_form_lock&form_id=${formId}&uid=${uid}&allinnonce=${nonce}`;
        navigator.sendBeacon(url);
    }
}


// const checkFormLock = async (formId,uid, restUrl,nonce) => {
//     console.log("RESTURL FROM UTILITIES: " + restUrl);
//     try{
//         let response = await fetch(`${restUrl}?action=check_form_lock&form_id=${formId}&uid=${uid}`, 
//             {headers: {
//                 'AllIn-Nonce': nonce,
//         }})

//         let data = await response.json();
//         //data = JSON.parse(data);
//         if(data.locked){
//             return true;
//         }
//         return false;
//     }
//     catch{
//         return false;
//     }
// }

const _formLockCache = new Map();

const checkFormLock = async (formId,uid, restUrl,nonce) => {
    //console.log("RESTURL FROM UTILITIES: " + restUrl);

    if(!formId || !uid || !restUrl){
        console.warn("checkFormLock skipped", {
            formId,
            uid,
            restUrl
        });
        return false;
    }

    const cacheKey = `${formId}_${uid}`;

    // reuse active request only
    if(_formLockCache.has(cacheKey)){
        return await _formLockCache.get(cacheKey);
    }

    try{
        const request = fetch(
            `${restUrl}?action=check_form_lock&form_id=${formId}&uid=${uid}`,
            {
                headers: {
                    'AllIn-Nonce': nonce,
                }
            }
        )
        .then(async(response)=>{
            let data = await response.json();

            return !!data.locked;
        })
        .catch(()=>{
            return false;
        })
        .finally(()=>{
            // remove cache after request completes
            _formLockCache.delete(cacheKey);
        });

        _formLockCache.set(cacheKey, request);

        return await request;
    }
    catch{
        return false;
    }
}

const getUrlFromFileId = async (fileId,restUrl,nonce) => {
    let response = await fetch(`${restUrl}'?action=get_file_url&file_id=${fileId}`, 
        {headers: {
            'AllIn-Nonce': nonce,
        }})
    let data = await response.json();
    return data;
}

const hideRevealInputs = (el) => {
    let hiders = [];
    if(Array.isArray(el)){
        hiders = el.map(item => Array.from(item.querySelectorAll('[data-hider]'))).flat().filter((item)=> item.length);
        el =  el[0].closest('form');
    }
    else{
        hiders = el.querySelectorAll('[data-hider]');
    }
    if(hiders.length>0){
        hiders.forEach(hider=>{
            hideRevealInput(hider, el);
            hider.addEventListener('change',hideRevealInputOnChange)
        });
    }

}
const hideRevealInput=(hider, form, dispatch = false)=>{
    let target = hider.dataset.hider;
    let targetEl = form.querySelector(`.${target}`);
    let revealKey = hider.dataset.reveal;
    let shouldReveal = false;
    if(hider.type=='checkbox'){
        shouldReveal = hider.checked;
    }
    else{
        shouldReveal = hider.value === revealKey;
    }
    if(shouldReveal){
        if(targetEl){
            targetEl.classList.remove('hidden');
        }
    }
    else{
        if(targetEl){
            targetEl.classList.add('hidden');
            targetEl.querySelectorAll('input,select,textarea').forEach(input=>{
                input.value = '';
                if(dispatch){
                    input.dispatchEvent(new Event('input'));
                }
            });
        }
    }
}

const hideRevealInputOnChange=(e)=>{
    let hider = e.currentTarget;
    let form = hider.closest('form');
    hideRevealInput(hider, form, true);
}

const removeHideRevealInputs = (el) => {
    if(!el) return;
    let hiders = el.querySelectorAll('[data-hider]');
    if(hiders.length>0){
        hiders.forEach(hider=>{
            hider.removeEventListener('change',hideRevealInputOnChange);
        });
    }
}

const validateURL = (urlField) =>{
    if(!urlField.value) return;
    urlField.removeAttribute('aria-invalid');
    urlField.removeAttribute('aria-describedby');
    urlField.classList.remove('error');
    let error = urlField.parentNode.querySelector(`#${urlField.id}_error`);
    if(error){
        error.remove();
    }
    if(urlField?.value){
        try{
            const currentUrl = new URL(urlField.value);
            const { protocol } = currentUrl;

            if (protocol !== 'http:' && protocol !== 'https:') {
                currentUrl.protocol = 'https:';
                urlField.value = currentUrl.toString();
            }
        }
        catch(error){
            urlField.value = `https://${urlField.value}`;
        }
    }
}

const validateURLDirect = (url) =>{
    if(!url) return ''; 
    try{
        const currentUrl = new URL(url);
        const { protocol } = currentUrl;

        if (protocol !== 'http:' && protocol !== 'https:') {
            currentUrl.protocol = 'https:';
            url = currentUrl.toString();
        }
    }
    catch(error){
        url = `https://${url}`;
    }
    return url;
}

const validatePhone = (phoneField) => {

}

const languages = {
    'en':'English',
    'cy':'Cymraeg',
    'ga':'Gaeilge',
    'gd':'Gaelic'
}

export { 
    validateForm, 
    validatePassword, 
    validateEmail, 
    validateGToken, 
    gRecaptcha, 
    validationHandler, 
    validationHandlerClear, 
    hideRevealPassword, 
    setFileValueFromDataUrl,
    decodeEntities,
    lockForm,
    releaseFormLock,
    releaseFormLockwithBeacon,
    checkFormLock,
    getUrlFromFileId,
    hideRevealInputs,
    removeHideRevealInputs,
    validateURL,
    validateURLDirect,
    validatePhone,
    languages
};